<!--
  -- 特定设备，弹窗，(选择设备，指定设备详情，设备是否可升级)
-->
<template>
  <el-dialog
    title="特定设备"
    :visible.sync="innerVisible"
    append-to-body
    :before-close="handleClose"
    :close-on-click-modal="false"
    @open="onOpenDialog"
  >
    <div class="dialog-container">
      <el-table
        v-loading="loading"
        :data="pagedTableData"
        max-height="420"
        style="width: 100%"
        size="medium"
        :header-cell-style="{ background: '#F5F6F7' }"
      >
        <el-table-column prop="deviceId" label="设备ID" />
        <el-table-column prop="upgradeFlag" label="搜索结果">
          <template slot-scope="scope">
            {{ scope.row.upgradeFlag ? '可升级' : '不可升级' }}
          </template>
        </el-table-column>
        <el-table-column prop="deviceUuid" label="设备UUID">
          <template slot-scope="scope">
            {{ scope.row.deviceUuid || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="deviceName" label="设备名称">
          <template slot-scope="scope">
            {{ scope.row.deviceName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="spaceName" label="家庭名称">
          <template slot-scope="scope">
            {{ scope.row.spaceName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="operate" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <div slot="footer">
      <el-button size="14" @click="handleClose()">取 消</el-button>
      <el-button type="primary" size="14" @click="submitForm('form')">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { postCheckSpecialDeviceId } from "@/api/product/product-details"

export default {
  name: "specificDeviceDialog",
  props: {
    deviceIdList: { // 设备ID集合，字符串形式的，以;分割的；例如："123;456;789"
      type: String,
      default: ""
    },
    productId: { // 产品ID
      type: String,
      default: ""
    }
  },
  data() {
    return {
      innerVisible: false,
      loading: true,
      tableData: [],
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    total() {
      return this.normalizedTableData.length
    },
    normalizedTableData() {
      return Array.isArray(this.tableData) ? this.tableData : []
    },
    pagedTableData() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.normalizedTableData.slice(start, start + this.pageSize)
    }
  },
  methods: {
    open() {
      this.innerVisible = true
    },
    // 获取特定设备详情
    getSpecificDeviceDetails() {
      this.loading = true
      const params = {
        deviceIdList: this.deviceIdList,
        productId: this.productId
      }
      postCheckSpecialDeviceId(params).then(res => {
        const data = res.data && res.data.data
        this.tableData = Array.isArray(data) ? data : []
        this.currentPage = 1
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        this.loading = false
      })
    },
    // 弹窗打开的时候
    onOpenDialog() {
      this.getSpecificDeviceDetails()
    },
    // 删除
    handleDelete(row) {
      this.tableData = this.normalizedTableData.filter(item => item.deviceId !== row.deviceId)
      this.correctCurrentPage()
    },
    correctCurrentPage() {
      const maxPage = Math.max(Math.ceil(this.total / this.pageSize), 1)
      if (this.currentPage > maxPage) {
        this.currentPage = maxPage
      }
    },
    // 每页条数改变时触发
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
    },
    // 当前页变时触发
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleClose() {
      this.innerVisible = false
      this.tableData = []
      this.currentPage = 1
      this.pageSize = 10
    },
    emitDeviceIdList(list) {
      const deviceIdList = list.map(item => item.deviceId).filter(Boolean).join(';')
      this.$emit('update-deviceIdList', deviceIdList)
      this.handleClose()
    },
    submitForm() {
      const tableData = this.normalizedTableData
      // 查询无结果时保留外层原输入，避免把用户填写的设备ID清空
      if (!tableData.length) {
        this.handleClose()
        return
      }

      const notUpgradeableList = tableData.filter(item => !item.upgradeFlag)
      const upgradeableList = tableData.filter(item => item.upgradeFlag)

      if (!notUpgradeableList.length) {
        this.emitDeviceIdList(upgradeableList)
        return
      }

      const deviceIds = notUpgradeableList
        .map(item => item.deviceId || item.did)
        .filter(Boolean)
        .join('，')

      this.$confirm(`${deviceIds}，无法创建升级任务`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.emitDeviceIdList(upgradeableList)
      }).catch(() => {})
    }
  }
}
</script>
<style scoped lang="scss">

</style>
